export const containsLetters = (value: string) => {
  return /[a-zA-Z]/.test(value);
};
